[
  {
    "number": "1",
    "question": "Je possède déjà mes verres, que faire?",
    "answer": "Si vous possédez déjà des verres correcteurs, nous pouvons dans la plupart des cas les adapter à une nouvelle monture sur mesure. Lors de votre rendez-vous, nous analysons leurs dimensions, leur état et leur compatibilité avec la monture envisagée. Si nécessaire, nous vous conseillerons sur la meilleure solution pour garantir confort visuel et durabilité."
  },
  {
    "number": "2",
    "question": "Existe-t-il des modèles de montures à acheter?",
    "answer": "Nous proposons une sélection de modèles de base servant de point de départ ou d’inspiration. Chaque monture peut ensuite être personnalisée selon vos envies (formes, dimensions, couleurs, finitions). Notre démarche reste centrée sur le sur-mesure, afin de créer une pièce unique parfaitement adaptée à votre visage."
  },
  {
    "number": "3",
    "question": "En quoi consiste le service après-vente?",
    "answer": "Notre service après-vente inclut les ajustements, le nettoyage professionnel, le polissage ainsi que les petites réparations liées à l’usage quotidien. Nous restons disponibles pour assurer le confort et la longévité de votre monture. En cas de besoin plus important, nous proposons également des services de rénovation ou de remplacement de certaines pièces."
  },
  {
    "number": "4",
    "question": "J’ai un visage spécial, est-ce possible de concevoir une monture? ",
    "answer": "Absolument. Le sur-mesure prend tout son sens dans ce type de situation. Nous réalisons une analyse précise de votre morphologie (largeur du visage, arête nasale, position des yeux, etc.) afin de concevoir une monture parfaitement adaptée, tant sur le plan esthétique que fonctionnel."
  },
  {
    "number": "5",
    "question": "Comment puis-je choisir les couleurs et les motifs?",
    "answer": "Nous mettons à votre disposition une large gamme de plaques d’acétate, allant des teintes classiques aux motifs plus audacieux. Lors du rendez-vous, nous vous guidons dans le choix en tenant compte de votre style, de votre carnation et de vos préférences. Vous pouvez également combiner plusieurs matériaux ou jouer sur les transparences pour un rendu unique."
  },
  {
    "number": "6",
    "question": "Travaillez-vous avec opticiens partenaires?",
    "answer": "Oui, nous collaborons avec un réseau d’opticiens partenaires en Suisse. Ils peuvent vous accompagner pour le choix et l’adaptation de vos verres correcteurs. Nous travaillons en étroite coordination afin de garantir un résultat final optimal, tant sur le plan visuel qu’esthétique."
  },
  {
    "number": "7",
    "question": "Où se trouve votre boutique?",
    "answer": "Notre atelier-boutique est situé à Mervelier dans le Jura suisse. Nous recevons uniquement sur rendez-vous afin de vous offrir un accompagnement personnalisé dans un cadre calme et dédié à la création."
  }
]